import { usePageEventContext, withPageEvent } from '../../../shared/flow-event';
import { createInitialState, createTracker } from './tracker';
import type {
  LoginByPasswordOneCredentialOptionalFlowEventDefinition,
  LoginByPasswordOneCredentialOptionalFlowEventState,
} from './types';

export function useLoginByPasswordOneCredentialOptionalFlowEvent() {
  return usePageEventContext<
    LoginByPasswordOneCredentialOptionalFlowEventDefinition
  >();
}

export function withLoginByPasswordOneCredentialOptionalFlowEvent<
  Props extends object = {}
>() {
  return withPageEvent<
    LoginByPasswordOneCredentialOptionalFlowEventDefinition,
    LoginByPasswordOneCredentialOptionalFlowEventState,
    Props
  >(createInitialState(), createTracker());
}
